import Pretender from 'pretender';

function pretend() {
  const rooturl = 'https://configurator-api.remeha.nl'; //eslint-disable-line
  const server = new Pretender();
  const headers = { 'Content-Type': 'application/json' }; //eslint-disable-line

  // browser-sync
  server.get('http://localhost:3000/browser-sync/socket.io/', server.passthrough);
  server.post('http://localhost:3000/browser-sync/socket.io/', server.passthrough);

  // hot-update
  server.get('*.hot-update.json', server.passthrough);
  server.get('/*.hot-update.json', server.passthrough);

  // log unhandled requests
  server.unhandledRequest = (verb, path, request) => {
    console.log('Unhandled pretender request:', request, path, verb); // eslint-disable-line
  };
}

export default pretend;



// WEBPACK FOOTER //
// ./js/pretender/main.js